import styled from 'styled-components'

export const EvaluationFinishWrapper = styled.div`
  padding: 0 8px;
`
